import React from 'react'
import { ReactComponent as TrashIcon } from 'presentation/assets/icons/trash-icon.svg'
import CardNew from 'presentation/shared/components/CardNew'
import DividerNew from 'presentation/shared/components/DividerNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import { CidV2Props } from 'presentation/contexts/surgical-order-v2/types'
import * as S from './styles'
import { DeleteIconButton } from '../../components/styles'
import { AddItemButton, EmptyListState } from '../components'

type Props = {
  initialRows: CidV2Props[]
  onDelete: (cidCode: string) => void
  onAddCid?: () => void
  showAddButton?: boolean
}

function CidsList({
  initialRows,
  onDelete,
  onAddCid,
  showAddButton = false
}: Props) {
  if (initialRows.length === 0) {
    return (
      <EmptyListState
        message="Nenhum CID foi adicionado ainda"
        showAddButton={showAddButton}
        onAdd={onAddCid}
        addLabel="Adicionar CID"
      />
    )
  }

  return (
    <CardNew
      background="neutral25"
      padding="1rem"
      style={{ borderRadius: '8px' }}
    >
      {initialRows.map((row, rowIndex) => {
        const isLastRow = rowIndex === initialRows.length - 1

        return (
          <div key={row.code}>
            <S.CidItem>
              <SupportTextNew
                size="xxxsmall"
                weight="semiBold"
                color="textPrimary"
                as="div"
                style={{ flex: 1 }}
              >
                {row.code} - {row.description}
              </SupportTextNew>

              <DeleteIconButton size="small" onClick={() => onDelete(row.code)}>
                <TrashIcon width={18} height={18} />
              </DeleteIconButton>
            </S.CidItem>
            {!isLastRow && (
              <DividerNew marginTop="0.75rem" marginBottom="0.75rem" />
            )}
          </div>
        )
      })}

      {showAddButton && (
        <AddItemButton onClick={onAddCid} label="Adicionar CID" />
      )}
    </CardNew>
  )
}

export default CidsList
